import { CompanyContext } from 'contexts/CompanyContextProvider';
import linkIcon from 'images/icons/svg/link-1.svg';
import { Button } from 'primereact/button';
import React, { useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { EpdLinks } from 'routes/EpdRoutes';
import styled from 'styled-components';
import { Container, EditFull } from 'styles/Styles.styled';

import { YES_NO } from 'components/v2/compiler/constants';
import CompilerSelectControlledComponent from 'components/v2/epd-compiler-inputs/CompilerSelectControlledComponent';
import WizardTextInputComponent from 'components/v2/epd-wizard-inputs/WizardTextInput';
import TitleAndBack from 'components/v2/TitleAndBack';
import { withGreyBackground } from 'pages/v2/WithGreyBackground';
import { Skeleton } from 'primereact/skeleton';
import { useGetCopyGroupId, useGetEPD } from 'services/api/queries';
import { FieldPanel, WizardHeaderGrid } from 'styles/v2/Styles.styled';

const ShowGroupEpd: React.FunctionComponent = () => {
  const { epdid } = useParams<{ epdid: string; copyGroupId: string }>();

  const epd = useGetEPD(epdid).data;
  const groupId = useGetCopyGroupId(epd?.versionId!).data;

  const { changeCompany } = useContext(CompanyContext);
  const history = useHistory();

  const hasDualRegistration = [
    { value: false, label: YES_NO.NO },
    { value: true, label: YES_NO.YES },
  ];

  const viewEPDObject = () => {
    if (groupId) {
      changeCompany?.(epd?.epdOwner?.companyId);
      history.push(EpdLinks.editCopyEpd(groupId));
    }
  };

  return (
    <Container>
      <EditFull>
        <WizardHeaderGrid>
          <TitleAndBack
            title={epd?.name !== undefined ? epd.name : <Skeleton width="311px" height="34px" />}
            backTo={'Back to EPDs'}
            onBack={() => history.push(EpdLinks.epdsList())}
          />
        </WizardHeaderGrid>
        <FieldPanel>
          <div>
            <WizardTextInputComponent label="EPD name" title={epd?.name} value={epd?.name} name="name" disabled />
            <ButtonBox>
              <Button
                icon={<ShowDetailsIcon src={linkIcon} alt="link" />}
                style={{ fontSize: 14, fontWeight: 500 }}
                type="button"
                label="View Copy Group"
                text
                onClick={viewEPDObject}
                disabled={false}
              />
            </ButtonBox>
          </div>

          <WizardTextInputComponent
            label="Registration number"
            value={epd?.registrationNumber}
            name="registrationNumber"
            disabled
            style={{ marginBottom: '26px' }}
          />
          <WizardTextInputComponent
            label="Organisation"
            title={epd?.epdOwner?.companyName}
            value={epd?.epdOwner?.companyName}
            name="organisation"
            disabled
          />
          <CompilerSelectControlledComponent
            label="Dual registration"
            name="IsDualRegistration"
            options={hasDualRegistration}
            value={hasDualRegistration.find((x) => x.value == epd?.isDualRegistration)}
            placeholder="Select..."
            isClearable={false}
            disabled
            onChanged={undefined}
          />
        </FieldPanel>
      </EditFull>
    </Container>
  );
};

const ShowDetailsIcon = styled.img`
  width: 15px;
  height: 15px;
  margin-right: 5px;
  cursor: pointer;
`;

const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  max-height: 70px;
  margin-top: 6px;
  cursor: pointer;

  .p-button.p-button-text {
    padding: 0;
    background-color: transparent;
    border: none;
    ${(props) => props.theme.fonts.standard};
  }
  .p-button.p-button-text:hover {
    background-color: transparent;
  }
  .p-button.p-button-text:disabled {
    color: #757575;
  }
`;

export default withGreyBackground(ShowGroupEpd);
